// Get value from Cookie
export const getCookieValue = (name: string) => {
  if (typeof window !== 'undefined') {
    const cookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(`${name}=`));
    return cookie ? cookie.split('=')[1] : null;
  }
};
